stringifyDeterministic = require('json-stringify-deterministic')
nanoid = require('nanoid')

angular.module('rjmNg.common.services').factory 'utils', [
  "md5"
  (md5) ->

    setHashKey = (obj, h) ->
      if h
        obj.$$hashKey = h
      else
        delete obj.$$hashKey
      return

    isRegExp = (value) ->
      return toString.call(value) is '[object RegExp]'

    # Creates a deep copy of `source`, which should be an object or an array.
    # This function will NOT handle circular dependencies
    #
    # If no destination is supplied, a copy of the object or array is created.
    # If a destination is provided, all of its elements (for array) or properties (for objects)
    #   are deleted and then all elements/properties from the source are copied to it.
    #   If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
    #   If `source` is identical to 'destination' an exception will be thrown.
    #
    # @param {*} source The source that will be used to make a copy.
    #                 Can be any type, including primitives, `null`, and `undefined`.
    # @param {(Object|Array)=} destination Destination into which the source is copied. If
    #    provided, must be of the same type as `source`.
    # @returns {*} The copy or updated `destination`, if `destination` was specified.
    copy : (source, destination) ->

      unless destination?
        destination = source
        if source?
          if angular.isArray source
            destination = @copy(source, [])
          else if angular.isDate source
            destination = new Date(source.getTime())
          else if angular.isObject(source)
            destination = @copy(source, {})
      else
        if source is destination
          throw "Can't copy! Source and destination are identical."
        if angular.isArray(source)
          destination.length = 0;
          destination.push @copy(s) for s in source
        else
          h = destination.$$hashKey
          angular.forEach(destination, (value, key) ->
            delete destination[key]
          )
          for key of source
            destination[key] = @copy(source[key])

          if h?
            destination.$$hashKey = h

      return destination

    # Change the position of an item in an array.
    changePosition: (items, newIndex, oldIndex) ->
      itemToMove = items.splice(oldIndex, 1)[0]
      items.splice(newIndex, 0, itemToMove)

    # Attempt to arrange the items in the items array such that they match
    # the order of the items in the referenceArray. if valueFunction is
    # specified, it will be invoked upon each item and should return a value
    # to compare to the items in referenceArray. Items not present in
    # referenceArray will be appended to the end of the list of items.
    matchArrayOrder: (referenceArray, items, valueFunction) ->
      unmatchedIndex = items.length

      _.sortBy items, (item) ->
        if valueFunction?
          value = valueFunction(item)
        else
          value = item

        index = referenceArray.indexOf(value)

        actualIndex = if index >= 0 then index else unmatchedIndex

        if index >= 0
          return index
        else
          return unmatchedIndex++

    # Given an $http response, determines whether or not the request was
    # canceled (as by a timeout or a promise).
    requestWasCanceled: (response) ->
      response.status in [-1, 0]

    # Given an object, and a path (e.g. 'foo.bar.baz'), set the property value.
    # Create any intermediate objects which don't exist.
    set: (object, path, value) ->

      [intermediateProperties..., childProperty] = path.split('.')

      for property in intermediateProperties
        unless object[property]?
          object[property] = {}
        object = object[property]

      object[childProperty] = value

    # Given a key and an object, returns the corresponding property value of an
    # object. Nested children are supported--the key for each successive parent
    # object should be separated by `.` (e.g. `foo.bar`).
    get: (object, path) ->
      return unless object?

      properties = path.split('.')

      for property in properties
        unless object[property]?
          return undefined
        object = object[property]

      return object

    # Converts HTML attribute value to the integer. Returns 0 for undefined or
    # non-number attribute values.
    readIntAttribute: (attribute) ->
      if attribute?
        parsed = parseInt(attribute)
        return if isNaN(parsed) then 0 else parsed
      else
        return 0

    # Generate Hash from Object in deterministic way. Which mean that for two
    # objects a and b hashes will be equal even if they have different order of
    # key-value pairs
    #
    # a = {"foo": 0, "bar": 1}
    # b = {"bar": 1, "foo": 0}
    # objToHash(a) === objToHash(b)
    objToHash: (obj) ->
      objStr = stringifyDeterministic(obj)
      return md5.createHash(objStr)

    generateGUID: (sequence, length) ->
      return nanoid.customAlphabet(sequence, length)()

    isJsonObj: (str) ->
      try
        data = JSON.parse(str)
        if angular.isObject(data) and not angular.isArray(data)
          return true
        else
          return false
      catch
        return false

    chunks: (arr, size = 2) ->
      return arr.map(
          (x, i) -> i % size is 0 and arr.slice(i, i + size)
        ).filter(
          (x) -> x
        )
]
